<script>
export default {
  name: 'EcsIdleTimer',

  props: {
    // Idle time in seconds
    duration: {
      type: Number,
      required: true
    },
    events: {
      type: Array,
      default: () => ['mousemove', 'keypress']
    }
  },

  data() {
    return {
      timer: undefined
    };
  },

  mounted() {
    this.setTimer();
    for (let i = this.events.length - 1; i >= 0; i -= 1) {
      window.addEventListener(this.events[i], this.clearTimer);
    }
  },

  beforeDestroy() {
    clearTimeout(this.timer);
    for (let i = this.events.length - 1; i >= 0; i -= 1) {
      window.removeEventListener(this.events[i], this.clearTimer);
    }
  },

  methods: {
    idle() {
      this.$emit('idle');
    },

    setTimer() {
      this.timer = window.setTimeout(this.idle, this.duration * 1000);
    },

    clearTimer() {
      clearTimeout(this.timer);
      this.setTimer();
    }
  },

  render() {
    return this.$scopedSlots.default({});
  }
};
</script>
